import React, { PureComponent } from 'react';
import { array, bool } from 'prop-types';
import OfferSourceListItem from './OfferSourceListItem';
import { STATIC_PATH } from '../../config';

const badgesIds = [12, 13];
const badgesImages = {
  12: `${STATIC_PATH}/img/offers/badges/vk.png`,
  13: `${STATIC_PATH}/img/offers/badges/mytarget.png`,
};

class OfferSourceList extends PureComponent {
  static propTypes = {
    sources: array.isRequired,
    selected: array.isRequired,
    invert: bool.isRequired,
  };

  static defaultProps = {
    sources: [],
    selected: [],
    invert: false,
  };

  renderSourceListBadges = (list = []) => (
    <div className="offer-source-list-badges" key="offer-source-list-badges">
      {list.map(id => (
        <img src={badgesImages[id]} key={id} />
      ))}
    </div>
  );

  renderSourcesList = (list = []) => {
    const {sources, invert, prefix} = this.props;
    return (
      <ul className="offer-source-list" key="offer-source-list">
        {sources.map(source =>
          list.includes(source.id) ? (
            <OfferSourceListItem key={source.id} source={source} invert={invert} prefix={prefix}/>
          ) : null,
        )}
      </ul>
    );
  };

  renderSourceListItems = () => {
    const { invert, selected } = this.props;
    let items = [];

    if (invert) {
      const badges = selected.filter(id => badgesIds.includes(id));

      if (badges.length) {
        items.push(this.renderSourceListBadges(badges));
      }

      const strings = selected.filter(id => !badgesIds.includes(id));
      items.push(this.renderSourcesList(strings));
    } else {
      items.push(this.renderSourcesList(selected));
    }

    return items;
  };

  render() {
    return this.renderSourceListItems();
  }
}

export default OfferSourceList;
